import React, { useMemo } from "react";

import { ThemeProvider as MuiV4ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import { useTheme } from "@/src/contexts/ThemeContext";
import { buildMuiTheme, buildMuiV4Theme } from "@/src/theme/muiTheme";

import type { JSX } from "react";

interface AppMuiThemeProviderProps {
  children: React.ReactNode;
}

export default function AppMuiThemeProvider({
  children,
}: AppMuiThemeProviderProps): JSX.Element {
  const { resolvedTheme } = useTheme();
  const muiTheme = useMemo(() => buildMuiTheme(resolvedTheme), [resolvedTheme]);
  const muiV4Theme = useMemo(
    () => buildMuiV4Theme(resolvedTheme),
    [resolvedTheme],
  );
  return (
    <MuiThemeProvider theme={muiTheme}>
      <MuiV4ThemeProvider theme={muiV4Theme}>{children}</MuiV4ThemeProvider>
    </MuiThemeProvider>
  );
}
